<template>
    <div>
        <div v-if="pending">
            <BaseSpinner />
        </div>
        <template v-else-if="!entry" /> <!-- empty case for when there is no entry, nuxt will show an error -->
        <article v-else>
            <HeroBasic
                :title="entry?.title"
                :image="entry?.image?.[0]"
                :description="entry?.textarea"
            >
                <template
                    v-if="entry?.parent"
                    #backlink
                >
                    <NuxtLink :to="localePath(`/${entry?.parent?.uri}`)">
                        <div class="sr-only">{{ t('a11y.return-to') }}</div>
                        <BaseIcon icon="chevron-left" />
                        {{ entry?.parent?.title }}
                    </NuxtLink>
                </template>
            </HeroBasic>

            <FlexibleSections
                v-if="entry.flexibleSections"
                :sections="entry.flexibleSections"
            />
        </article>
    </div>
</template>

<script setup>
import { formatISO } from 'date-fns';
import getPage from '~/graphql/queries/getPage.graphql';

const { t } = useI18n();
const localePath = useLocalePath();
const route = useRoute();

const { variables: defaultVariables }  = useCraftGraphql();

const variables = computed(() => {
    const now = formatISO(Date.now(), { representation: 'date' });

    return {
        ...defaultVariables,
        section: 'teamMembers',
        slug: route.params.slug,
        now: ['or', `>= ${now}`, null]
    };
});

const response = await useAsyncQuery({
    query: getPage,
    variables
});

// using response.pending in template is not reactive???
const pending = computed(() => response?.pending.value);

const { craftEntry: entry } = useCraftPageEther(response);

const mainStore = useMainStore();
watchEffect(() => {
    mainStore.toggleNewsletterSubscribe(entry.value?.showNewsletterSubscribe ?? false);
});
</script>
